import React, { forwardRef } from "react";
import classnames from "classnames";
import styled from 'styled-components';
import IBuildrProps from '../../utilities/IBuildrProps';

interface ITabContentProps extends IBuildrProps {
    children: any;
}

export default styled(forwardRef((props: ITabContentProps, ref: any) => {
    const { cmsId, editorClassObj, className, children } = props;

    return (
        <div ref={ref} data-id={cmsId} className={classnames(className,  editorClassObj)}>
           {children}
        </div>
    );
}))`
// Always stacks columns in mobile
@media(max-width:992px) {
    flex: 0 0 100%!important;
    max-width: 100%!important;
}
`;
